import { RRIConfirmDeleteModalSettings } from '../modal/confirm-delete-modal-settings.interface';
import { RRIBaseTableActionSettings } from './base-table-action-settings.interface';

export interface RRITableDeleteActionSettings<T>
  extends RRIBaseTableActionSettings {
  modalSettings: RRIConfirmDeleteModalSettings<T>;
  delete: (row: T) => void;
}
